(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["julieth-navigation"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', function(event) {
  const link = event.target.closest('.jh-mobile-links a');
  if (link) link.closest('details').removeAttribute('open');
});
  } catch(e) { console.error(e); }
})();

})();
